// src/pages/ReportMisusePage.jsx
import React from 'react';
import PageHeader from './PageHeader';
import { useLanguage } from '../../context/LanguageContext';
import { FaFlag, FaExclamationCircle, FaCheckCircle } from 'react-icons/fa';

const ReportMisusePage = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      pageHeaderTitle: "Report Misuse",
      title: "Report Any Misuse or Concern",
      subtitle: "Help us keep ST MatchZone safe for everyone.",
      howToReport: "How to Report",
      steps: [
        "Go to the suspicious profile or message.",
        "Click the 'Report' button (flag icon).",
        "Select the reason (fake profile, harassment, etc.).",
        "Submit – our team reviews within 24 hours."
      ],
      commitment: "We take every report seriously and take immediate action to protect our community. Thank you for helping us maintain a safe and trusted platform."
    },
    Tamil: {
      pageHeaderTitle: "தவறை புகாரளி",
      title: "ஏதேனும் தவறு அல்லது கவலையை புகாரளியுங்கள்",
      subtitle: "எல்லோருக்கும் ST MatchZone-ஐ பாதுகாப்பாக வைக்க உதவுங்கள்.",
      howToReport: "எப்படி புகாரளிப்பது",
      steps: [
        "சந்தேகத்திற்குரிய சுயவிவரம் அல்லது செய்திக்கு செல்லுங்கள்.",
        "புகாரளி பொத்தானை (கொடி ஐகான்) கிளிக் செய்யுங்கள்.",
        "காரணத்தை தேர்ந்தெடுங்கள் (போலி சுயவிவரம், தொல்லை போன்றவை).",
        "சமர்ப்பிக்கவும் – எங்கள் குழு 24 மணி நேரத்தில் மதிப்பாய்வு செய்யும்."
      ],
      commitment: "ஒவ்வொரு புகாரையும் தீவிரமாக எடுத்துக்கொண்டு உடனடி நடவடிக்கை எடுக்கிறோம். பாதுகாப்பான தளத்தை பராமரிக்க உதவியதற்கு நன்றி."
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader showBackButton={true} backTo="/" title={txt.pageHeaderTitle} />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <img src="https://www.tegfcu.com/wp-content/uploads/2025/02/romance-scams.png" alt="Report Misuse" className="w-full h-96 object-cover rounded-2xl shadow-xl mb-10" />
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">{txt.title}</h1>
          <p className="text-xl text-gray-600">{txt.subtitle}</p>
        </div>

        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-10 flex items-center justify-center gap-4">
            <FaFlag className="text-rose-600 text-4xl" /> {txt.howToReport}
          </h2>
          <ol className="space-y-6">
            {txt.steps.map((step, index) => (
              <li key={index} className="bg-white rounded-2xl p-8 shadow-lg flex items-start gap-6">
                <FaCheckCircle className="text-3xl text-rose-600 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-700 leading-relaxed">{index + 1}. {step}</p>
              </li>
            ))}
          </ol>
          <div className="mt-12 text-center bg-rose-50 rounded-2xl p-10">
            <FaExclamationCircle className="text-5xl text-rose-600 mx-auto mb-4" />
            <p className="text-xl text-gray-700 leading-relaxed">{txt.commitment}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportMisusePage;